// @flow
import { NavigateBefore } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";

type Props = {
	fallBackRoute: string,
	title: string
};

const NavigateBackButton = (props: Props) => {
	const {fallBackRoute, title, ...other } = props
	const history = useHistory()
	// Check if user navigated here from another page (via referrer)
	const fromAnotherPage = document.referrer && document.referrer !== window.location.href;
	
	const navigateBack = () => {
		if (history.length > 1 && fromAnotherPage) {
			history.goBack()
		} else {
			history.push(fallBackRoute)
		}
	}
	return (
		<Button
			onClick={navigateBack}
			startIcon={<NavigateBefore/>}
			{...other}
		>
			{title}
		</Button>
	);
};

export default NavigateBackButton